import { Injectable, ErrorHandler } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CONFIGURATION } from '../app.constants';
import { Observable } from 'rxjs';
import { DncData } from '../models';

declare var config: any;
@Injectable({ providedIn: 'root' })
export class ManageDncService {
    constructor(private http: HttpClient) { }
    private AdmtServiceUrl = CONFIGURATION.baseUrls.ADMTServiceURL;



    SaveDncData(body: DncData): Observable<DncData>{
        const url = this.AdmtServiceUrl + 'Dnc/SaveDncData';
        let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: httpHeaders };
        return this.http.post<DncData>(url, body, options)
        
    }
   
    DncDataBind(did): Observable<any>{
        const url = this.AdmtServiceUrl + 'Dnc/GetDncData?dlrId=' + did;
        return this.http.get(url);
    }

    GetDncDataById(dncGuid):Observable<any>{
        const url = this.AdmtServiceUrl + 'Dnc/GetDncDataById?dncGuid=' + dncGuid;
        return this.http.get(url);
           
    }
    
    DeleteDncData(dncId): Observable<any> {
        const url = this.AdmtServiceUrl  + 'Dnc/DelDncData?dncId=' + dncId;
        return this.http.get(url);
    }

    DncListBind(dlrId): Observable<any> {
        const url = this.AdmtServiceUrl  + 'Dnc/GetDncData?dlrId=' + dlrId;
        return this.http.get(url);
    }
    getMasterDealers(source_id,file_type_id): Observable<any> {
        const url = this.AdmtServiceUrl + 'Dnc/getDealersList?source_id='+source_id+'&file_type_id='+file_type_id;
        return this.http.get(url);
    }
    
}